<template>
  <div class="pageContent">
    <div class="table_box" v-if="tableData.length>0">
      <template v-for="(item, i) in tableData">
        <div class="activity_card" :key="i">
          <div class="card_left">
            <img
              v-if="item.url"
              style="width: 100%;height: 100%"
              :src="item.url"
            />
            <img
              v-else
              style="width: 100%;height: 100%"
              src="http://zht.58zltc.com/public/uploads/20210619174140e22cb3109.jpg"
            />
          </div>
          <div class="card_right"  @click="platformcard(item,0)">
            <span style="font-size: 18px;font-weight: 560">{{
              item.name
            }}</span>
            <span>创建时间: {{ item.create_time | dataFormat }}</span>
            <span>
              <span>{{card_type_title[item.card_type]}}</span>
              <span
                v-text="
                  item.card_type == 1
                    ? item.card_amount
                    : item.card_type == 2
                    ? item.card_num
                    : item.show_card_duration_info
                "
              ></span>
            </span>
            <div class="detil" :title="item.detail">
              <span>活动说明: </span>
              <span>{{ item.detail }}</span>
            </div>
          </div>
          <div class="card_right2">
            <div class="card_right2_con">
              <el-tag
                size="small"
                :type="items[item.join_status].type"
                effect="dark"
                v-if="item.join_status !== 0"
                style="margin-right: 10px"
              >
                {{ items[item.join_status].name }}
              </el-tag>
              <el-button
                v-if="item.join_status !== 1"
                type="text"
                v-text="item.join_status == 2 ? '设置' : '报名'"
                @click="platformcard(item,1)"
              ></el-button>
            </div>
            <div>
              <div style="color: red;font-size: 24px">
                ¥{{ item.sale_amount }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-empty style="height: 500px;" v-else description="暂无数据"></el-empty>
    <el-pagination
      background
      :hide-on-single-page="total_num <= 5"
      style="width: 90%;margin: 20px auto; "
      layout="prev, pager, next"
      :page-size="5"
      :total="total_num"
      @current-change="current_page"
    >
    </el-pagination>
  </div>
</template>
<script>
import { platformcard_card_list, platformcard_join_card } from "@/api/platform_card";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      card_type_title: ["", "面值: ", "次数: ", "时效: "],
      items: [
        { type: "info", name: "未报名" },
        { type: "warning", name: "审核中" },
        { type: "success", name: "审核通过" },
        { type: "danger", name: "审核拒绝" }
      ],
      tableData: [],
      tableRowClassName: "22",
      page: 1,
      total_num: 0,
      value: true
    };
  },
  mounted() {
    this.get_tableData();
  },
  methods: {
    current_page(val) {
      console.log(val);
      this.page = val;
      this.get_tableData();
    },
    async get_tableData() {
      try {
        const res = await platformcard_card_list({
          app_id: this.app_id,
          page: this.page
        });
        this.tableData = res.data.result;
        this.total_num = res.data.total_num;
        this.tableData.forEach((item, i) => {
          if (item.card_type == 3) {
            item.show_card_duration_info =
              item.card_duration_info.day +
              "天" +
              item.card_duration_info.hour +
              "时" +
              item.card_duration_info.minute +
              "分" +
              item.card_duration_info.second +
              "秒";
          }
          // item.detail =item.detail.replace(/<[^>]*>|/g,"");
        });
      } catch (e) {
        console.log(e);
      }
    },
    platformcard(row,val) {
      if(val == 1){
        if (row.join_status == 2) {
          this.$router.push({
            path: "/apply/newVip/13/card/activityCard/set_card",
            query: {
              id: row.id
            }
          });
        } else {
          platformcard_join_card({
            app_id: this.app_id,
            id: row.id
          }).then(res => {
            if (res.code == 200) {
              this.$message.success("报名成功,请等待管理员审核");
              this.get_tableData()
              // this.$router.back(-1);
            } else {
              this.$message(res.msg);
            }
          });
        }
      }else {
        this.$router.push({
          path: "/apply/newVip/13/card/activityCard/card_detil",
          query: {
            id: row.id,
            val:val
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./card.scss";
.pageContent {
  border: 20px solid #f1f2f6;
  padding: 0 20px 10px 20px;
  height: 100%;
  overflow: auto;
  .options {
    line-height: 79px;
  }
  .table_box {
    margin-bottom: 20px;
  }
  .form_input {
    width: 240px;
  }
}

</style>
